// extracted by mini-css-extract-plugin
export default {"card":"NewPasswordCard_card__YllSU"};